import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  justify-content: space-between;
  padding-top: 1.75rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.colors.davysGrey};
  align-items: flex-end;
  margin-top: 10px;
  padding: 0;
`;

export const ProgressModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  text-align: center;
`;

export const Spinner = styled.div`
  border: 3px solid ${(props) => props.theme.colors.aquaHaze};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;

  &.creating-trigger {
    border-top: 3px solid ${(props) => props.theme.colors.curiousBlue};
  }

  &.creating-flow {
    border-top: 3px solid ${(props )=> props.theme.colors.darkOrange};
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const SuccessIcon = styled.div`
  color: ${(props) => props.theme.colors.mediumGreen};
  font-size: 30px;
  margin: 0 auto 10px;
`;

export const SubText = styled.div`
  color: #${(props) => props.theme.colors.grey};
  margin-top: 5px;
`;

export const SuccessText = styled.div`
  color: ${(props) => props.theme.colors.mediumGreen};
`;
